/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './formTag.scss';


const FormTag = (props) => {
  const {
    configFile,
    value
  } = props;

  const [bk, setBk] = useState({color:"#ff0000"});
  const [color, setColor] = useState({color:"#ffffff"});
  const [text,setText] =useState({text:"not configured"});
  

  useEffect(() => {
    if(configFile.colorWhen){
      const newColor = configFile.colorWhen.find(color => color.value=== value);
      if(newColor)
        setColor(newColor);
    }

    if(configFile.bkWhen){
      const newBk  = configFile.bkWhen.find(color => color.value === value);
      if(newBk)
        setBk(newBk);
    }
    
    if(configFile.textWhen){
      const newText = configFile.textWhen.find(text => text.value===value);
      if(newText)
        setText(newText);
    }
  }, [value]);


  return (
    <div style={{marginTop:'10px'}}>
      <div className="form-tag__style" style={{
          backgroundColor:bk.color,
          maxWidth:configFile.maxTagWidth,
          margin:"auto",
          color:color.color}}>
        {text.text}
      </div>
    </div>
  );
};

FormTag.propTypes = {
  configFile: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number,PropTypes.bool]),
  
};

FormTag.defaultProps = {
  configFile: undefined,
  value: '',
};

export default FormTag;
